<h2 mat-dialog-title>Add Dataservice</h2>
@if (!isLoading) {
    <form [formGroup]="addDataServiceForm" novalidate>
        <mat-dialog-content class="mat-typography">
            <div class="form-grid">

                <search-company class="full" appearance="fill" [searchCompanyForm]="addDataServiceForm"></search-company>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>DataService ID</mat-label>
                    <input matInput name="dataservice_id" formControlName="dataservice_id" required autocomplete="dataservice_id">
                    <mat-error>DataService ID is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>DataService Name</mat-label>
                    <input matInput name="name" formControlName="dataservice_name" required autocomplete="name">
                    <mat-error>DataService Name is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>DataService Type</mat-label>
                    <input matInput name="data_service_type" formControlName="data_service_type" required autocomplete="data-service-type">
                    <mat-error>DataService Type is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Contact</mat-label>
                    <input matInput name="contact" formControlName="contact" autocomplete="contact">
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Phone</mat-label>
                    <input matInput name="phone" formControlName="phone" autocomplete="phone">
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Description</mat-label>
                    <textarea matInput name="description" formControlName="description" autocomplete="description"></textarea>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Host</mat-label>
                    <input matInput name="host" formControlName="host" required autocomplete="host" placeholder="bolt://0.0.0.0 | neo4j://">
                    <mat-error>Host is required.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Port</mat-label>
                    <input matInput name="port" formControlName="port" required autocomplete="port">
                    <mat-error>Port is required.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Database Name</mat-label>
                    <input matInput name="database_name" formControlName="database_name" required autocomplete="database_name">
                    <mat-error>Database Name is required.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Database User</mat-label>
                    <input matInput name="user" formControlName="user" required autocomplete="user">
                    <mat-error>Database User is required.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Database Password</mat-label>
                    <input matInput name="password" formControlName="password" required autocomplete="password">
                    <mat-error>Database Password is required.</mat-error>
                </mat-form-field>

                <mat-slide-toggle class="full" name="initialize_ds" formControlName="initialize_ds">Activate DB Replication</mat-slide-toggle>

            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-flat-button color="primary" [disabled]="addDataServiceForm.invalid" (click)="onAddDataService()">Save</button>
        </mat-dialog-actions>
    </form>
}@else{
    <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="custom-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
}
